export const LocalStorageKeys = {
  Specs: 'specs',
  CurrentProfileId: 'current-profile-id',
  ChannelView: 'channel-view',
};
